<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <div class="home-title mt-4 card-title">
            The Welland Canal
            <v-btn text to="/">Go Back</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row>
        <v-col lg="4" sm="12" v-for="(item, index) in cardData" :key="index">
          <v-card>
            <v-img min-height="400" max-height="400" :src="getImgUrl(item.headerImage)"></v-img>
            <v-card-title class="card-title">{{item.title}}</v-card-title>
            <v-card-subtitle>{{item.subtitle}}</v-card-subtitle>
            <v-card-text v-html="item.text"></v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn  v-if="item.link != ''" text :to="item.link" class="card-title">Explore</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>
export default {
  name: "TheWellandCanal",
  components: {},
  data() {
    return {
      cardData: [
        {
          headerImage: "Image_1__First_Canal_985_5_208_inside_preview.jpg",
          title: "The First Canal",
          subtitle: "Operated 1829-1844",

          text: ` 40 Wooden Locks<br/>
		33.5 m (100 feet) long by 6.7 m (22 feet) wide<br/>
		2.4 m (8 feet) deep<br/>

			<p>
		In 1824, the Welland Canal Company began construction on the First Welland Canal. It opened between Lake Ontario and Chippawa on the Niagara River in 1829, with the section to Lake Erie opened in 1833. For William Hamilton Merritt, the businessman behind the canal, it was important the canal serve two purposes: providing shipping with a way to bypass Niagara Falls, and a regular supply of water for water-powered mills and other industries along the canal. Vessels and barges moved through the canal towed by teams of horses and mules. Built with 40 wooden locks that deteriorated rapidly, canal maintenance quickly became a problem, and the costs soon overwhelmed the Welland Canal Company. In 1841, the colonial government took over responsibility for the Welland Canal, and embarked on a plan to rebuild and improve the canal.
		</p>`,
          link: "/FirstCanal",
        },
        {
          headerImage:
            "Image_1__Second_Canal_996_10_2_entrance_to_Welland_Canal___Port_Colborne.jpg",
          title: "Second Canal",
          subtitle: "Operated 1845-1886",

          text: `27 Stone-built Locks<br/>
		45.7 m (150 feet) long by 8.1 m (26.5 feet) wide.<br/>
		2.7 m (9 feet) deep<br/>


			<p>
		In 1845, the Second Welland Canal opened to navigation, this time with 27 stone-built locks. The canal was also deepened to the same depth as channels further downstream on the lower St. Lawrence River in order to open navigation all the way from Lake Erie to Quebec and Montreal.  In 1867, with Confederation, the Welland Canal came under the control of the federal Department of Railways and Canals. The advent of steam-powered vessels with larger iron and steel hulls in the mid-nineteenth century meant that the canal locks became too small, and it was time to consider a new canal. Steam-powered tugs were also starting to replace horses and mules in towing vessels through the canal.
		</p>`,
          link: "/SecondCanal",
        },
        {
          headerImage: "Photo_5__Third_Canal_2007_5_42.jpg",
          title: "Third Canal",
          subtitle: "Operated 1887-1931",

          text: `26 cut stone locks, <br/>
82.3 m (270 feet) long by 13.7 m (45 feet) wide.<br/>
4.3 m (14 feet) deep<br/>



			<p>
		In 1887, the completed Third Welland Canal opened for navigation. Not only did it have a total of 26 stone-built locks, much larger in size than the previous canal, it also followed a different route up the Niagara Escarpment through Grantham and Thorold Townships.  This was a new era for the canal and for shipping, as a new type of vessel appeared, adapted specifically for shipping on the Great Lakes:  the “canaler.”  The canalers were bulk carriers that were essentially self-propelled barges, built to fit the dimensions of the canal locks.  As well, although provisions had been made for a towpath for the Third Canal, new steam-powered tugboats quickly replaced the teams of horses and mules that had once towed vessels through the canal.  Despite the tremendous increase in the size and depth of the canal locks, advances in shipbuilding meant that once again, by the turn of the twentieth century, the Third Canal locks were too small to accommodate the newest ships.
		</p>`,
          link: "/ThirdCanal",
        },

        {
          headerImage: "Photo_4__Fourth_Canal_979_79_1.jpg",
          title: "Fourth Canal",
          subtitle: "Operation 1932 - present",

          text: `8 concrete locks<br/>
233.5 m (766 feet) long by 24.4 m (80 feet) wide<br/>
8.3 metres (27 feet) deep<br/>


			<p>
		Plans were underway before the First World War to build another canal, this time with major changes.  The Welland Ship Canal, as it was called, was for transportation purposes only, as water-powered mills and industries had become obsolete.  Advances in engineering and the availability of electric pumps and motors to work the locks meant that the new canal would only have 8 locks.  Other significant developments included a new entrance to the Welland Canal on Lake Ontario at Port Weller, and a new route with twinned, flight locks up the escarpment at Thorold, so the canal now follows an almost direct north-south route through the Niagara Peninsula.  Although construction began in 1912, it was put on hold during the First World War, with the completed canal finally open for navigation in 1932.  In 1959, the Welland Canal became part of the St. Lawrence Seaway.
		</p>`,
          link: "/FourthCanal",
        },
        {
          headerImage: "Map_1__Realignment.jpg",
          title: "Realignment",
          subtitle: "",

          text: `<p>
		In 1973, the 13.4 km long Welland Canal Realignment or Bypass opened to ship traffic. The bypass was constructed to straighten out the section of the Canal which passed through the City of Welland. A new, straighter and wider channel was cut east of Welland from Port Robinson to Ramey’s Bend, allowing for faster navigation. Three tunnels under the canal carry local highways and railway tracks under the canal, so road and railway traffic is not delayed by ships in the canal.  The old channel through Welland is now called the Welland Recreational Canal reflecting its new use for recreation and sport.
		</p>`,
          link: "",
        },
      ],
    };
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/images/" + pic);
    },
  },
};
</script>

<style>
</style>